import { Link } from 'react-router-dom';
import { LucideIcon } from 'lucide-react';

type NavLinkProps = {
  to: string;
  icon: LucideIcon;
  label: string;
  isActive?: boolean;
};

export default function NavLink({ to, icon: Icon, label, isActive }: NavLinkProps) {
  return (
    <Link
      to={to}
      className={`flex items-center space-x-2 px-4 py-2 rounded-lg ${
        isActive 
          ? 'text-indigo-600 bg-indigo-50' 
          : 'text-gray-600 hover:bg-gray-50'
      }`}
    >
      <Icon className="w-5 h-5" />
      <span>{label}</span>
    </Link>
  );
}